import {Component, OnInit, Optional, ChangeDetectionStrategy} from '@angular/core';
import {PostbackService} from '../../../../../../services/postback/postback.service';
import {Postback} from '../../../../../../models/postback/postback';

import {SnackbarService} from '../../../../../../services/snackbar/snackbar.service';
import {LoaderService} from '../../../../../../services/loader/loader.service';
import {RouterLink} from '@angular/router';
import {IsGrantedDirective} from '../../../../../../directives/is-granted/is-granted.directive';
import {Paginator} from '../../../../../../tools/pagination/paginator';
import {TableSorter} from '../../../../../../tools/table-sorter/table-sorter';
import {PaginatorComponent} from '../../../../../layout/paginator/paginator.component';
import {TableSorterDirective} from '../../../../../../directives/table-sorter/table-sorter.directive';
import {TableSorterHeaderDirective} from '../../../../../../directives/table-sorter/table-sorter-header.directive';
import {UserEventModalComponent} from '../../../../../layout/user-event-modal/user-event-modal.component';
import {DialogService} from '../../../../../../services/dialog/dialog.service';
import {PartnerTabComponent} from '../../../partner-tab/partner-tab.component';
import {Partner} from '../../../../../../models/partner/partner';
import {IsGranted} from '../../../../../../decorator/is-granted';
import {MetaTitle} from '../../../../../../decorator/meta-title';
import {ConfirmDirective} from '../../../../../../directives/confirm/confirm.directive';
import {PartnerPostbackLogComponent} from '../partner-postback-log/partner-postback-log.component';

@Component({
  selector: 'app-partner-postback-list',
  imports: [
    RouterLink,
    IsGrantedDirective,
    PaginatorComponent,
    TableSorterDirective,
    TableSorterHeaderDirective,
    ConfirmDirective
],
  templateUrl: './partner-postback-list.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './partner-postback-list.component.scss'
})
@IsGranted(['ROLE_API_POSTBACK_READ'])
@MetaTitle('Postback')
export class PartnerPostbackListComponent implements OnInit {

  protected partner!: Partner;
  protected postbacks: Postback[] = [];

  paginator = new Paginator();
  tableSorter = new TableSorter('id');

  constructor(
    protected loader: LoaderService,
    private dialog: DialogService,
    private snackbar: SnackbarService,
    private postbackService: PostbackService,
    @Optional() private partnerTab: PartnerTabComponent
  ) {
  }

  ngOnInit(): void {
    this.partnerTab.partnerSubject.subscribe((partner: Partner | null) => {
      if (partner) {
        this.partner = partner;

        this.fetchAll();
      }
    });
  }

  openPostbackModal(postback: Postback): void {
    this.dialog.openDialog(UserEventModalComponent, {
      data: {
        title: 'Postback logs',
        key: 'postback-' + postback.id
      },
      backdrop: false
    }).subscribe(() => {
    });
  }

  openPostbackLogModal(postback: Postback): void {
    this.dialog.openDialog(PartnerPostbackLogComponent, {
      data: {
        postback
      },
    }).subscribe(() => {
    });
  }

  fetchAll(): void {
    const partner = this.partner;
    if (!partner || !partner.id) {
      return;
    }

    this.loader.startLoading();

    this.postbackService.findAll({
      partnerId: partner.id,
      groups: 'goal,offers'
    }, this.paginator, this.tableSorter).subscribe((postbacks: Postback[]) => {
      this.postbacks = postbacks;

      this.loader.stopLoading();
    });
  }

  delete(postback: Postback): void {
    if (postback.id) {
      this.postbackService.delete(postback.id).subscribe(() => {
        this.fetchAll();
        this.snackbar.success('Postback successfully deleted.');
      });
    }
  }

  getOffers(postback: Postback): string {
    return postback.offers.map(offer => offer.id).join(', ');
  }
}
